export const DeviceInfoTableHeader = {
  columns: {
    // id: {
    //   title: 'ID Пакета'
    // },
    dt0: {     // dt0
      title: 'Дата закрытия суток',
      width: '150px'
    },
    dts: {
      title: 'Текущие время модема',
      width: '150px'
    },
    modTime: {
      title: 'Дата получения пакета',
      width: '150px'
    },
    dv0: {
      title: 'Объём по закрытии суток, Л.'
    },
    mv0: {
      title: 'Oбъём за закрытый месяц, Л'
    },
    wd0: {
      title: 'Состояние накопленное за сутки.'
    },
    wm0: {
      title: 'Состояние накопленное за месяц'
    },
    wp: {
      title: 'Состояние накопленное за период от сброса'
    },
    rxInfoLoraSnr: {
      title: 'SNR'
    },
    rxInfoRssi: {
      title: 'RSSI'
    },
    meff: {
      title: 'Счетчик магнитного воздействия'
    },
    vbat: {
      title: 'Напряжение питани'
    },
    temp: {
      title: 'Температура'
    },
    min: {
      title: 'MIN'
    },
    max: {
      title: 'MAX'
    }
  },
  actions: {
    add:    false,
    edit:   false,
    delete: false
  },
  pager: {
    perPage: 10
  }
};




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/models/DeviceInfoTableHeader.ts